export function noop(): void {
  /* empty */
}
